<ng-container *ngIf="reportInfo$ | async as rep; else loadingOrError">
  <div class="headers" *ngIf="!compact">
    <div class="report-name">
      {{ reportInfo?.name
      }}{{ subReport != null && loading == false ? " - " + rep?.name : "" }}
      <button
        class="qna-button"
        mat-flat-button
        *ngIf="reportInfo?.qnA != null && subReport == null"
        (click)="openQnA()"
      >
        QnA
        <mat-icon
          matTooltipPosition="right"
          matTooltipClass="blue-tooltip"
          [svgIcon]="'globe-chatai'"
        ></mat-icon>
      </button>
    </div>
    <giq-bread-crumbs [crumbs]="crumbs"></giq-bread-crumbs>
  </div>
  <div
    class="content"
    [class.customWidth]="customWidth"
    [style.width]="customWidth ? rep.width : ''"
  >
    <giq-report-problem
      class="problems"
      [id]="reportId"
      [description]="reportDescription"
      type="Report"
      *ngIf="!compact"
    ></giq-report-problem>
    <div id="vizContainer" class="report-viz"></div>
    <giq-loading *ngIf="loading" class="loading-icon"></giq-loading>
  </div>
</ng-container>

<ng-template #loadingOrError>
  <div class="loading-content">
    <ng-container *ngIf="error$ | async; else loading">
      <span>{{ errorMessage }}</span>
    </ng-container>
    <ng-template #loading>
      <giq-loading class="loading-icon"></giq-loading>
      <span class="loading-text">Loading report. . .</span>
    </ng-template>
  </div>
</ng-template>
